import * as joint from "jointjs";

type Side = { x: string; y: string; offset: { x: number; y: number }; rotate: number };

const SIDES: Side[] = [
  { x: "50%", y: "0%", offset: { x: 0, y: -16 }, rotate: -90 },
  { x: "100%", y: "50%", offset: { x: 16, y: 0 }, rotate: 0 },
  { x: "50%", y: "100%", offset: { x: 0, y: 16 }, rotate: 90 },
  { x: "0%", y: "50%", offset: { x: -16, y: 0 }, rotate: 180 },
];

const createArrow = (side: Side) =>
  new joint.elementTools.Button({
    useModelGeometry: true,
    markup: [
      {
        tagName: "circle",
        selector: "button",
        attributes: { r: 9, fill: "#35495d", opacity: 0.9, cursor: "crosshair" },
      },
      {
        tagName: "path",
        attributes: {
          transform: `rotate(${side.rotate})`,
          d: "M -3 -3 L 3 0 L -3 3 Z",
          fill: "#FFFFFF",
          stroke: "none",
          "pointer-events": "none",
        },
      },
    ],
    x: side.x,
    y: side.y,
    offset: side.offset,
    action: function (evt: joint.dia.Event) {
      // @ts-ignore
      this.paper.trigger("keaelement:link", this, evt);
    },
  });

export const createConnectArrowTools = () => SIDES.map(createArrow);
